// extracted by mini-css-extract-plugin
export default {"main":"EditDeliveryPage_main__IvwUQ"};